export default __webpack_public_path__ + "static/media/1020.d15fd313.png";